import React, { useState } from "react";
import { FaGoogle, FaLinkedinIn, FaInstagram, FaPhone } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

import ritikaImg from "../../assets/images/Team/ritika.webp";
import prasoonImg from "../../assets/images/Team/prasoon.webp";

const C = {
  deepRed:   "#A10F1A",
  gold:      "#C79A3B",
  cream:     "#F3EEE4",
  darkGold:  "#8C6A24",
  richBrown: "#5A3A1A",
  black:     "#1A1A1A",
  bgLight:   "#FAF7F2",
  white:     "#FFFFFF",
};

const attorneys = [
  {
  name: "Ms. Ritika Gautam",
  role: "Managing Partner Litigation Head & Litigation Head",
  img: ritikaImg,
  bio: "Renowned for unwavering commitment to client interests across civil, criminal, commercial and IP law. Practices before the Supreme Court of India  and all major High Courts.",
  socials: [
    {
      icon: FaGoogle,
      link: "https://www.google.com/search?q=R+%26+P+Law+Team+%7C+Criminal+%7C+Bail+%7C+Domestic+Violence+%7C+NDPS+%7C+POCSO+%7C+Divorce+%7C+Cyber+Crime&stick=H4sIAAAAAAAA_-NgU1I1qDC2NEhONTZOSTGzNDU3MjW3MqgwMTNJMTYxNTAyTjW2SExOW8QaH6SgphCg4JNYrhCQWFSSl1pUrFCj4FyUmZuZl5gDZDolZoIol_zc1OKSzGSFsMz8nNS85FSgmJ9LQDCQCvB3DvYHKcksyy8CSzhXJqUWgQ1JBQC8BQpQiwAAAA&hl=en-GB&mat=CYHB-pCwiS_NElcBTVDHnlhmvaT5yVWMn9kOhSzb2OJKLtO-Q369XJU2zfTXHzhWBMhHERNigx73bcRMFHR1HW_lX91vSWg1PuYOUv_67f8oQDE-LSbeoWfYOHxiY20ltgo&authuser=1"
    },
    {
      icon: FaLinkedinIn,
      link: "https://linkedin.com/in/ritika-gautam"
    },
    {
      icon: FaInstagram,
      link: "https://instagram.com/ritika.gautam"
    }
  ],
},
{
  name: "Mr. K. Prasoon Ranjan",
  role: "Founder Partner",
  img: prasoonImg,
  bio: "Years of proven track record in complex litigation across pharmaceuticals, IT, labour, matrimonial, trademark and debt recovery matters.",
  socials: [
    {
      icon: FaGoogle,
      link: "https://www.google.com/search?q=R+%26+P+Law+Team+%7C+Criminal+%7C+Bail+%7C+Domestic+Violence+%7C+NDPS+%7C+POCSO+%7C+Divorce+%7C+Cyber+Crime&stick=H4sIAAAAAAAA_-NgU1I1qDC2NEhONTZOSTGzNDU3MjW3MqgwMTNJMTYxNTAyTjW2SExOW8QaH6SgphCg4JNYrhCQWFSSl1pUrFCj4FyUmZuZl5gDZDolZoIol_zc1OKSzGSFsMz8nNS85FSgmJ9LQDCQCvB3DvYHKcksyy8CSzhXJqUWgQ1JBQC8BQpQiwAAAA&hl=en-GB&mat=CYHB-pCwiS_NElcBTVDHnlhmvaT5yVWMn9kOhSzb2OJKLtO-Q369XJU2zfTXHzhWBMhHERNigx73bcRMFHR1HW_lX91vSWg1PuYOUv_67f8oQDE-LSbeoWfYOHxiY20ltgo&authuser=1"
    },
    {
      icon: FaLinkedinIn,
      link: "https://linkedin.com/in/k-prasoon-ranjan"
    },
    {
      icon: FaSquareXTwitter,
      link: "https://x.com/prasoonranjan"
    }
  ],
},
];

const services = [
  {
    id: "01",
    title: "Individual Case",
    desc: "Personalized legal support ensuring thorough attention  and full protection of your rights.",
    link: "/services/",
  },
  {
    id: "02",
    title: "Legal Protection",
    desc: "Safeguarding your rights with expert guidance  and sharp strategic solutions.",
    link: "/services/",
  },
  {
    id: "03",
    title: "Private Counsel",
    desc: "Trusted private legal services tailored to protect your specific interests with discretion.",
    link: "/services/",
  },
];

const AttorneyCard = ({ lawyer }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="attorney-card-wrapper"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ position: "relative", cursor: "default" }}
    >
      {/* Image container */}
      <div style={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 12,
        aspectRatio: "3/4",
        border: `2px solid ${hovered ? C.gold : "rgba(140,106,36,0.2)"}`,
        transition: "border-color 0.4s",
        boxShadow: hovered
          ? "0 24px 60px rgba(161,15,26,0.2)"
          : "0 8px 30px rgba(90,58,26,0.1)",
      }}>
        <img
          src={lawyer.img}
          alt={lawyer.name}
          style={{
            width: "100%", height: "100%",
            objectFit: "cover", objectPosition: "top center",
            display: "block",
            transform: hovered ? "scale(1.06)" : "scale(1)",
            transition: "transform 0.9s ease",
          }}
        />

        {/* Gradient overlay */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to top, rgba(161,15,26,0.85) 0%, rgba(26,10,10,0.3) 50%, transparent 100%)",
          opacity: hovered ? 1 : 0.7,
          transition: "opacity 0.4s",
        }} />

        {/* Social Icons */}
        <div style={{
          position: "absolute", right: 14, top: "50%",
          display: "flex", flexDirection: "column", gap: 10,
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.4s, transform 0.4s",
          transform: hovered
            ? "translateY(-50%) translateX(0)"
            : "translateY(-50%) translateX(48px)",
        }}>
        {lawyer.socials.map((social, i) => {
  const Icon = social.icon;

  return (
    <a
      key={i}
      href={social.link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        width: 34,
        height: 34,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.1)",
        border: "1px solid rgba(255,255,255,0.15)",
        borderRadius: "50%",
        color: C.cream,
        fontSize: 12,
        cursor: "pointer",
        backdropFilter: "blur(6px)",
        transition: "background 0.3s",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = C.gold)}
      onMouseLeave={(e) =>
        (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
      }
    >
      <Icon />
    </a>
  );
})}
        </div>

        {/* Bottom name plate */}
        <div style={{
          position: "absolute", bottom: 0, left: 0, right: 0,
          padding: "1.5rem 1.5rem 1.25rem",
        }}>
          <p style={{
            fontSize: 10, color: C.gold,
            letterSpacing: "0.3em", textTransform: "uppercase",
            fontWeight: 700, margin: "0 0 5px", fontFamily: "sans-serif",
          }}>
            {lawyer.role}
          </p>
          <h4 style={{
            fontSize: 20, fontWeight: 700,
            color: C.cream, margin: 0,
            fontFamily: "'Georgia', serif",
          }}>
            {lawyer.name}
          </h4>

          {/* Gold underline animates on hover */}
          <div style={{
            height: 2, borderRadius: 2,
            background: C.gold,
            width: hovered ? "100%" : 32,
            transition: "width 0.6s ease",
            marginTop: 10,
          }} />
        </div>
      </div>

      {/* Bio card */}
      <div style={{
        marginTop: "1.25rem",
        padding: "1.25rem 1.5rem",
        background: hovered ? C.cream : C.white,
        border: `1px solid ${hovered ? "rgba(140,106,36,0.3)" : "rgba(140,106,36,0.12)"}`,
        borderLeft: `4px solid ${hovered ? C.deepRed : C.gold}`,
        borderRadius: 6,
        transition: "all 0.35s ease",
      }}>
        <p style={{
          fontSize: 13.5, color: C.richBrown,
          lineHeight: 1.8, margin: 0,
          fontFamily: "sans-serif",
        }}>
          {lawyer.bio}
        </p>
        <a href="/contact-us" style={{
          display: "inline-flex", alignItems: "center", gap: 7,
          marginTop: "0.85rem",
          fontSize: 10, fontWeight: 700,
          color: C.deepRed, letterSpacing: "0.2em",
          textTransform: "uppercase", fontFamily: "sans-serif",
          textDecoration: "none",
        }}>
          <FaPhone size={10} /> Book Consultation
        </a>
      </div>
    </div>
  );
};

const ServiceItem = ({ item, isLast }) => {
  const [hov, setHov] = useState(false);

  return (
    <div
      className="service-item-row"
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        borderBottom: isLast ? "none" : `1px solid rgba(140,106,36,0.12)`,
        background: hov ? "#FDF8F0" : C.white,
        transition: "background 0.3s",
      }}
    >
      {/* Number */}
      <span style={{
        fontSize: 48, fontWeight: 800,
        color: hov ? "rgba(161,15,26,0.12)" : "rgba(140,106,36,0.1)",
        fontFamily: "'Georgia', serif",
        lineHeight: 1, flexShrink: 0, userSelect: "none",
        transition: "color 0.3s",
      }}>
        {item.id}
      </span>

      {/* Content */}
      <div style={{ flex: 1 }}>
        <h5 style={{
          fontSize: 15, fontWeight: 700,
          color: hov ? C.deepRed : C.black,
          margin: "0 0 6px",
          fontFamily: "'Georgia', serif",
          letterSpacing: "0.04em",
          transition: "color 0.3s",
        }}>
          {item.title}
        </h5>
        <div style={{
          width: hov ? 28 : 0, height: 2,
          background: C.gold, borderRadius: 2,
          marginBottom: 8, transition: "width 0.4s",
        }} />
        <p style={{
          fontSize: 13.5, color: C.richBrown,
          lineHeight: 1.75, margin: 0, fontFamily: "sans-serif",
        }}>
          {item.desc}
        </p>
      </div>

      {/* Arrow */}
      <a href={item.link} className="service-item-arrow" style={{
        border: `1.5px solid ${hov ? C.deepRed : "rgba(140,106,36,0.3)"}`,
        color: hov ? C.deepRed : C.darkGold,
      }}>
        →
      </a>
    </div>
  );
};

const AttorneySection = () => (
  <section className="rp-attorney-section">
    {/* ══ RESPONSIVE STYLES ══ */}
    <style>{`
      .rp-attorney-section {
        width: 100%;
        background: ${C.bgLight};
        font-family: 'Georgia', 'Times New Roman', serif;
        box-sizing: border-box;
        overflow: hidden;
      }
      .rp-label-strip {
        background: ${C.deepRed};
        padding: 0.85rem 1.5rem;
        display: flex;
        align-items: center;
        gap: 16px;
      }
      .rp-header {
        padding: 2.5rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-bottom: 1px solid rgba(140,106,36,0.15);
      }
      .rp-header-desc {
        max-width: 100%;
      }
      .rp-attorney-grid {
        padding: 2.5rem 1.5rem;
        display: grid;
        grid-template-columns: 1fr;
        gap: 32px;
        max-width: 1100px;
        margin: 0 auto;
      }
      .rp-service-highlight {
        margin: 0 1.5rem 3rem;
        background: ${C.white};
        border: 1px solid rgba(140,106,36,0.2);
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 8px 40px rgba(90,58,26,0.08);
      }
      .rp-service-grid {
        display: grid;
        grid-template-columns: 1fr;
      }
      .rp-service-left {
        padding: 2.5rem 1.5rem;
        border-right: none;
        border-bottom: 3px solid ${C.gold};
      }
      .service-item-row {
        padding: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1;
      }
      .service-item-arrow {
        width: 38px;
        height: 38px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        text-decoration: none;
        font-size: 16px;
        transition: all 0.3s;
        margin-top: 8px;
      }

      /* Tablet & Desktop Adjustments */
      @media (min-width: 768px) {
        .rp-label-strip {
          padding: 0.85rem 4rem;
        }
        .rp-header {
          padding: 3.5rem 4rem 2.5rem;
          flex-direction: row;
          align-items: flex-end;
          justify-content: space-between;
        }
        .rp-header-desc {
          max-width: 360px;
        }
        .rp-attorney-grid {
          padding: 3.5rem 4rem 4rem;
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .rp-service-highlight {
          margin: 0 4rem 4rem;
        }
        .rp-service-grid {
          grid-template-columns: 5fr 7fr;
        }
        .rp-service-left {
          padding: 3.5rem;
          border-right: 3px solid ${C.gold};
          border-bottom: none;
        }
        .service-item-row {
          padding: 2rem 2.5rem;
          flex-direction: row;
          align-items: center;
          gap: 24px;
        }
        .service-item-arrow {
          margin-top: 0;
        }
      }
    `}</style>

    {/* ══ TOP LABEL STRIP ══ */}
    <div className="rp-label-strip">
      <div style={{ height: 1, width: 32, background: "rgba(199,154,59,0.6)" }} />
      <span style={{
        fontSize: 10, fontWeight: 700, color: C.gold,
        letterSpacing: "0.45em", textTransform: "uppercase", fontFamily: "sans-serif",
      }}>
        The Legal Minds
      </span>
    </div>

    {/* ══ HEADER ══ */}
    <div className="rp-header">
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
          <div style={{ width: 32, height: 2, background: C.deepRed, borderRadius: 2 }} />
          <span style={{
            fontSize: 10, fontWeight: 700, color: C.darkGold,
            letterSpacing: "0.45em", textTransform: "uppercase", fontFamily: "sans-serif",
          }}>
            Our Team
          </span>
        </div>
        <h2 style={{
          fontSize: "clamp(28px, 3.5vw, 48px)",
          fontWeight: 700, color: C.black,
          margin: 0, lineHeight: 1.2,
        }}>
          Expert Attorneys at{" "}
          <span style={{ color: C.deepRed, fontStyle: "italic", fontWeight: 400 }}>
            <br className="mobile-break" /> R &amp; P Law Team
          </span>
        </h2>
      </div>

      <p className="rp-header-desc" style={{
        fontSize: 14, color: C.richBrown,
        lineHeight: 1.8, fontFamily: "sans-serif", margin: 0,
        borderLeft: `2px solid ${C.gold}`, paddingLeft: 20,
      }}>
        Two experienced advocates. One shared mission to protect your rights
        with precision, strategy and integrity.
      </p>
    </div>

    {/* ══ ATTORNEY CARDS ══ */}
    <div className="rp-attorney-grid">
      {attorneys.map((lawyer, i) => (
        <AttorneyCard key={i} lawyer={lawyer} />
      ))}
    </div>

    {/* ══ SERVICE HIGHLIGHTS ══ */}
    <div className="rp-service-highlight">
      <div className="rp-service-grid">

        {/* Left narrative */}
        <div className="rp-service-left" style={{
          background: C.deepRed,
          display: "flex", flexDirection: "column", justifyContent: "center",
          position: "relative", overflow: "hidden",
        }}>
          {/* Decorative corners */}
          <div style={{ position: "absolute", top: 16, left: 16, width: 28, height: 28, borderTop: `2px solid rgba(199,154,59,0.35)`, borderLeft: `2px solid rgba(199,154,59,0.35)` }} />
          <div style={{ position: "absolute", bottom: 16, right: 16, width: 28, height: 28, borderBottom: `2px solid rgba(199,154,59,0.35)`, borderRight: `2px solid rgba(199,154,59,0.35)` }} />

          <span style={{
            fontSize: 10, fontWeight: 700, color: C.gold,
            letterSpacing: "0.45em", textTransform: "uppercase",
            fontFamily: "sans-serif", marginBottom: 16, display: "block",
          }}>
            Our Commitment
          </span>
          <h3 style={{
            fontSize: "clamp(24px, 2.5vw, 38px)",
            fontWeight: 700, color: C.cream,
            margin: "0 0 1.25rem", lineHeight: 1.2,
          }}>
            Designed for{" "}
            <span style={{ fontWeight: 300, fontStyle: "italic", opacity: 0.7 }}>
              Everyone.
            </span>
          </h3>
          <p style={{
            fontSize: 14, color: "rgba(243,238,228,0.65)",
            lineHeight: 1.85, margin: 0,
            fontFamily: "sans-serif", fontWeight: 300,
            borderLeft: `2px solid ${C.gold}`, paddingLeft: 18,
          }}>
            At R &amp; P Law Team, we believe quality legal support should
            be accessible. With deep expertise, we simplify complex legalities
             and fight for your rights.
          </p>
        </div>

        {/* Right services */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {services.map((item, idx) => (
            <ServiceItem
              key={item.id}
              item={item}
              isLast={idx === services.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AttorneySection;